export default function Header() {
    return (
        <h1>Header: TrypSync</h1>
    )
}